const translations = {
    loading: 'Loading',
    noDrones: 'No Drones',
    noMoreDrones: 'No More Drones'
};

export default translations;
